import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Form from "../components/Form";
import api from "../services/api";

const VerifyEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("");
  const hasVerifiedRef = useRef(false);

  useEffect(() => {
    if (hasVerifiedRef.current) {
      return;
    }

    hasVerifiedRef.current = true;

    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    setStatus("pending");
    if (!token) {
      setStatus("error-warning");
      setMessage("Missing verification token.");
      return;
    }
    // Call backend to verify email
    api
      .get(`/auth/verify-email?token=${token}`)
      .then((res) => {
        setStatus("success-info");
        setMessage(res.data.message || "Email verification successful.");
        // Login automat: salvează emailul în localStorage pentru precompletare
        const params = new URLSearchParams(location.search);
        const token = params.get("token");
        let email = "";
        try {
          // Decodăm tokenul JWT pentru a extrage emailul
          const payload = JSON.parse(atob(token.split(".")[1]));
          if (payload.email) {
            email = payload.email;
            localStorage.setItem("verifiedEmail", email);
          }
        } catch {
          // Ignore decode errors
        }
        // Redirect automat la login cu email prepopulat
        setTimeout(() => {
          navigate("/login", { state: { email } });
        }, 5000);
      })
      .catch((err) => {
        const details = err?.response?.data?.details?.[0];
        if (details === "Email is already verified") {
          setStatus("success-info");
          setMessage("Email verified.");
          // Redirect și pentru email deja verificat
          setTimeout(() => {
            navigate("/login");
          }, 5000);
        } else if (details === "Verification link is invalid or has expired") {
          setStatus("error-warning");
          setMessage("Verification link is invalid or has expired");
        } else {
          setStatus("error-warning");
          setMessage(details || "Verification failed. Try again.");
        }
      });
  }, [location.search, navigate]);

  if (status === "pending" || status === null) {
    return (
      <Form title="Email Verification" showCancel={false} showSubmit={false}>
        <p>Verifying your email...</p>
      </Form>
    );
  }

  if (status === "success-info") {
    return (
      <Form title="Email Verification" showCancel={false} showSubmit={false}>
        <p>{message}</p>
        <p>Redirecting to login...</p>
      </Form>
    );
  }

  return (
    <Form
      title="Email Verification"
      showCancel={false}
      showSubmit={false}
      footerLinks={
        <div className="form-footer-link">
          <Link to="/">Go Home</Link>
        </div>
      }
    >
      <p>{message}</p>
    </Form>
  );
};

export default VerifyEmail;
